import React from 'react'
import { default as ReactPlacesAutoComplete } from 'react-places-autocomplete'
import { useController } from 'react-hook-form'
import withStyles from '@material-ui/styles/withStyles'

const styles = () => ({
  dropDownContainer: {
    boxShadow: '0 0 5px',
    position: 'absolute', // so it doesn't push the contents down
    width: '100%', // display full width as per the ouer div whose position is relative
    zIndex: 2
  }
})

const searchOptions_fi = {
  types: ['(regions)'],
  componentRestrictions: { country: 'fi' }
}

// May use MUI's autocomplete to replace react-places-autocomplete
// See https://mui.com/components/autocomplete/#google-maps-place

const PlacesAutoComplete = ({
  classes,
  name,
  control,
  label,
  placeholder,
  defaultValue = '',
  labelStyle,
  onChangeOverride,
  onChange,
  searchOptions,
  disabled
}) => {
  const {
    field,
    fieldState: { invalid, error }
  } = useController({
    name,
    control,
    defaultValue: defaultValue
  })

  const handleChange = (e) => {
    if (typeof onChangeOverride === 'function') {
      onChangeOverride(e, field, fieldState)
    } else {
      onChange?.(e)
      field.onChange(e)
    }
  }

  return (
    <div>
      <label
        className="form-control-label"
        style={{
          fontSize: '14px',
          fontWeight: '500',
          color: error ? 'red' : 'grey',
          opacity: disabled ? 0.7 : 1,
          ...labelStyle
        }}
      >
        {label}
      </label>
      <ReactPlacesAutoComplete
        value={field.value}
        onChange={handleChange}
        searchOptions={searchOptions ? searchOptions_fi : null}
        disabled={disabled}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div style={{ position: 'relative' }}>
            <input
              {...getInputProps({
                placeholder: placeholder,
                className: 'location-search-input mt-1 full-width input-form',
                style: {
                  fontSize: '14px',
                  width: '100%',
                  lineHeight: '2em',
                  border: '1px solid gray',
                  paddingLeft: '5px',
                  opacity: disabled ? 0.7 : 1,
                  color: disabled ? 'gray' : 'black'
                }
              })}
              ref={field.ref}
              onBlur={field.onBlur}
              disabled={disabled}
            />
            {invalid && error && (
              <label
                className="error"
                style={{
                  color: 'red',
                  fontSize: '8px',
                  fontWeight: 'lighter',
                  marginTop: 0,
                  height: 0
                }}
              >
                {error}
              </label>
            )}
            <div className={classes.dropDownContainer}>
              {loading && (
                <div style={{ fontSize: '14px', padding: '10px' }}>
                  Loading...
                </div>
              )}
              {suggestions.map((suggestion, index) => {
                const className = suggestion.active
                  ? 'suggestion-item--active'
                  : 'suggestion-item'
                const style = suggestion.active
                  ? {
                      backgroundColor: '#fafafa',
                      cursor: 'pointer',
                      fontSize: '14px'
                    }
                  : {
                      backgroundColor: '#ffffff',
                      cursor: 'pointer',
                      fontSize: '14px'
                    }
                return (
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style
                    })}
                    key={index}
                  >
                    <span style={{ padding: '10px' }}>
                      {suggestion.description}
                    </span>
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </ReactPlacesAutoComplete>
    </div>
  )
}

export const HookAutoCompleteLocation = withStyles(styles)(PlacesAutoComplete)
